<template>
  <input class="field-input__inner form__input"
         ref="site"
         :placeholder="placeholder"
         :required="required"
         type="text"
         v-model="site"
         @change="onChangeSite"
         @blur="$emit('blur')"
         v-on:keyup.enter="keyupEnter"
  >
</template>
<script>
  export default {
    name: 'InputAddressSite',
    props: {
      placeholder: {
        type: String,
        default: 'Адрес вашего сайта*',
      },
      required: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        site: '',
      }
    },
    methods: {
      onChangeSite() {
        this.$emit('change-site', this.site);
      },
      keyupEnter() {
        this.$emit('keyup-enter');
      }
    }
  }
</script>
